var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container adventure-photography"},[_c('h2',[_vm._v("Adventure Photography")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.images),function(image){return _c('div',{staticClass:"col-xs-6 col-md-3"},[_c('thumbnail',{attrs:{"image":image}})],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5ac488","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/interests/hobbies/photography.vue
// module id = null
// module chunks = 